/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-27 11:26:52
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-19 17:08:41
 */
import Cookies from 'js-cookie';
const keys = {
	token: 'accessToken',
	publicDi: 'public_di',
};

const isDev = process.env.NODE_ENV === 'development';
const getDomain = (isApiDomain = true) => {
	let domain;
	if (isApiDomain) {
		let temp = location.hostname.split('.').reverse();
		domain = '.' + temp[1] + '.' + temp[0];
		// location.hostname == 'dev-part.modengyin.net.cn' 这种格式, 再取前一级。
		if (['net', 'cn', 'com'].indexOf(temp[1]) > -1) {
			domain = '.' + temp[2] + domain;
		}
		// 为了兼容二级域名，后端接口固定访问chaoyongtuan.com
		let defaultDomain = ['.vipsaas.com', '.hongrenxingxuan.com']; //默认走超佣团配置接口
		if (defaultDomain.includes(domain)) {
			domain = '.chaoyongtuan.com';
		}
	} else {
		let temp = location.hostname.split('.').reverse();
		domain = '.' + temp[1] + '.' + temp[0];
		// location.hostname == 'dev-part.modengyin.net.cn' 这种格式, 再取前一级。
		if (['net', 'cn', 'com'].indexOf(temp[1]) > -1) {
			domain = '.' + temp[2] + domain;
		}
	}
	return domain;
};
let Domain = isDev ? location.hostname : getDomain(false);
let newDomain = location.hostname;
const CookiesTools = {
	setToken(val) {
		Cookies.set(keys.token, val, { domain: newDomain, expires: 30 });
	},
	removeToken() {
		Cookies.remove(keys.token, { domain: Domain });
		Cookies.remove(keys.token, { domain: newDomain });
	},
	getToken() {
		return Cookies.get(keys.token);
	},
	setDi(val) {
		Cookies.set(keys.publicDi, val, { domain: newDomain, expires: 9999 });
	},
	getDi() {
		return Cookies.get(keys.publicDi);
	},
};

export default CookiesTools;
